import { Outlet } from "react-router";
import { Toaster } from "sonner";
import { NavigationProgress } from "@repo/ui/components/navigation-progress";

function CommonLayout() {
  return (
    <>
      <NavigationProgress />
      <Toaster richColors position="bottom-center" />
      <Outlet />
    </>
  );
}

export const route = {
  element: <CommonLayout />,
};
